import { IP_TYPE, NIC_TYPE_ETHERNET } from '../../../../../constants/network';

export const ESTIMATED_PARALLEL_WORKLOADS_OPTIONS = [
    { value: 1, label: '25' },
    { value: 2, label: '50' },
    { value: 3, label: '75' },
    { value: 4, label: '100+' },
];

export const buildSourceWorkersDataToPrefill = (appliance) => {
    const vsphere = appliance?.source_clouds?.vsphere?.deployment_configuration?.vsphere || {};
    const additionalConfigurations = vsphere.additional_configurations || [];
    return [vsphere, ...additionalConfigurations].map(buildSourceWorker);
};


export const prefillVmLevelFields = (appliance, form) => {
    const sourceWorkers = buildSourceWorkersDataToPrefill(appliance);
    const sourceWorkersCount =
      appliance.source_clouds?.vsphere?.deployment_configuration?.source_workers_count || sourceWorkers.length;
    const account = appliance?.source_clouds?.vsphere?.account || {};
    const vsphereConfig = appliance?.cloud_configuration?.vsphere || {};

    form.setFieldsValue({
        vcenterUrl: vsphereConfig.url || '',
        vcenterUsername: account?.auth?.credentials?.identity || '',
        vmLevelEnabled: true,
        sourceWorkersCount,
        sourceWorkers,
    });
};

const buildSourceWorker = (config = {}) => {
    const eth0 = config.network?.interfaces?.eth0 || {};
    const ipType = eth0.ip_type || IP_TYPE.DHCP;
    const isStatic = ipType === IP_TYPE.STATIC;

    return {
        vmName: config.source_worker_vm_name || '',
        datacenterName: config.datacenter_name || '',
        clusterName: config.cluster_name || '',
        datastoreName: config.datastore_name || '',
        resourcePoolName: config.resource_pool_name || '',
        folderName: config.folder_name || '',
        network: {
            networkName: eth0.network_name || config.network_name || '',
            ipType,
            ipAddr: isStatic ? eth0.ip_addr || '' : '',
            netmask: isStatic ? eth0.netmask || '' : '',
            gateway: isStatic ? config.network?.routes?.default_gateway || '' : '',
            primaryDns: isStatic ? config.network?.dns?.primary || '' : '',
            secondaryDns: isStatic ? config.network?.dns?.secondary || '' : '',
        },
    };
};

export const buildSourceCloudsPayload = (values) => {
    const sourceWorkersCount = values.sourceWorkersCount || 1;
    const workers = values.sourceWorkers || [];
    const sourceClouds = buildSourceWorkerConfigurationPayload(values);
    sourceClouds.vsphere.deployment_configuration.source_workers_count = sourceWorkersCount;

    if (sourceWorkersCount > 1) {
        const additionalConfigurations = [];
        for (let index = 1; index < sourceWorkersCount; index += 1) {
            const worker = workers[index] || {};
            additionalConfigurations.push({
                source_worker_vm_name: worker.vmName,
                datacenter_name: worker.datacenterName,
                cluster_name: worker.clusterName,
                datastore_name: worker.datastoreName,
                network_name: worker.network?.networkName,
                resource_pool_name: worker.resourcePoolName || undefined,
                folder_name: worker.folderName || undefined,
                network: buildNetworkDataFromFormData(worker.network),
            });
        }
        sourceClouds.vsphere.deployment_configuration.vsphere.additional_configurations = additionalConfigurations;
    }
    return sourceClouds;
};

export const buildSourceWorkerConfigurationPayload = (values) => {
    const worker = values.sourceWorkers?.[0] || {};
    return {
        vsphere: {
            account: {
                name: 'n/a',
                tenant_id: '',
                url: values.vcenterUrl,
                auth: {
                    auth_type: 'password',
                    credentials: {
                        identity: values.vcenterUsername,
                        secret: values.vcenterPassword,
                    },
                },
            },
            verify_ssl_certificates: false,
            auth: null,
            deployment_configuration: {
                vsphere: {
                    source_worker_vm_name: worker.vmName,
                    datacenter_name: worker.datacenterName,
                    cluster_name: worker.clusterName,
                    datastore_name: worker.datastoreName,
                    network_name: worker.network?.networkName || null,
                    resource_pool_name: worker.resourcePoolName || "",
                    folder_name: worker.folderName || "",
                    network: buildNetworkDataFromFormData(worker.network),
                },
            },
        },
    };
};

export const buildNetworkDataFromFormData = (network = {}) => {
    const ipType = network.ipType || IP_TYPE.DHCP;
    const isStatic = ipType === IP_TYPE.STATIC;

    const eth0 = {
        ip_type: ipType,
        type: NIC_TYPE_ETHERNET,
        network_name: network.networkName || null,
        dv_switch_name: '',
    };
    if (isStatic) {
        eth0.ip_addr = network.ipAddr || '';
        eth0.netmask = network.netmask || '';
    }

    const networkPayload = { interfaces: { eth0 } };
    if (isStatic) {
        if (network.gateway) {
            networkPayload.routes = {
                default_gateway: network.gateway,
            };
        }
        if (network.primaryDns || network.secondaryDns) {
            networkPayload.dns = {};
            if (network.primaryDns) {
                networkPayload.dns.primary = network.primaryDns;
            }
            if (network.secondaryDns) {
                networkPayload.dns.secondary = network.secondaryDns;
            }
        }
    }
    return networkPayload;
};
